<form [formGroup]="userAttributesForm" class="main">
    <div class="select-frequency mt-4">Select Frequency</div>
    <div class="frequency-button-container">
        <div class="col" *ngFor="let frequency of frequencies; let i=index">
            <input type="radio" [id]="i+'interest1'" [value]="frequency.value" formControlName="frequency"
                [(ngModel)]="currentFrequency" (change)="onFrequencyChange()">
            <label class="frequency-button" [for]="i+'interest1'">{{frequency.key}}</label>
        </div>
    </div>
    <div *ngIf="userAttributesForm.controls.frequency.invalid">
        <span class="error-text">Please select your nCash frequency</span>
    </div>
    <div class="max-amount">
        <p> <span class="">Interest </span>
            <span class="text-right amount"> ₹ {{interestOnlyAmount | number: '1.0-2'}}</span>
        </p>
    </div>
    <div class="note">
        <p>Note: Based on the Frequency selection the Interest Only amount will change</p>
    </div>
    <div class="select-frequency mt-4">Select Date</div>
    <div class="frequency-button-container">
        <div class="col" *ngFor="let date of dates; let i=index">
            <input type="radio" [id]="i+'interest2'" [value]="date.value" formControlName="date"
                [(ngModel)]="currentDate" (change)="onDateChange()">
            <label class="frequency-button" [for]="i+'interest2'">{{date.key}}<sup>th</sup> of Month</label>
        </div>
    </div>
    <div *ngIf="userAttributesForm.controls.date.invalid">
        <span class="error-text">Please select your nCash date </span>
    </div>
</form>